import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'

import './styles.css';

const Intro = () => {
    return (
        <section className="introWrapper">
            <div className="heroOrbs">
                <div className="orb orb1"></div>
                <div className="orb orb2"></div>
                <div className="orb orb3"></div>
                <div className="orb orb4"></div>
            </div>
            <div className="col1">
                <span>Olá,</span>
                <h1>Sou Romulo Eduardo.</h1>
                <h2>Fullstack & Cientista de Dados</h2>
                <h2>C# | Python | React</h2>
                <AnchorLink href="#bio">Me Conheça</AnchorLink>
            </div>
            <AnchorLink href="#bio" className="scrollIndicator" aria-label="Rolar para baixo">
                ↓
            </AnchorLink>
        </section>
    );
}

export default Intro;